import 'view/css/cheque-view.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileExcel,
  faPen,
} from '@fortawesome/free-solid-svg-icons';

import moment from 'moment';
import React, { useEffect, useState } from 'react';

import API from 'service/api';
import Util, { Data } from 'service/util';
import Loading from 'component/Loading';
import Protected from 'component/Protected';

import DatePicker from 'react-datepicker';
import ModalScreen from 'component/ModalScreen';
import PaymentCard from 'component/payment/PaymentCard';

const C_INIT_SHOW_COUNT = 300;
const today = moment().startOf('day').toDate();
const thisMonth = moment().startOf('month').toDate();

const ixday = (d)  => parseInt(moment(d).format('YYYYMMDD'), 10);
const ix2s  = (ix) => moment(String(ix)+'01', 'YYYYMMDD').format('YYYY-MM');

const PaymentView = (props) =>
{
  const [exporting, setExporting]   = useState(false);
  const [modal,     setModal    ]   = useState(null);

  const [ls_staff, setStaffList]    = useState([]);

  const [by_date,    setByDate]     = useState('create');
  const [queryMonth, setQueryMonth] = useState(thisMonth);
  const [sel_fdtm,   setFromDate]   = useState(today);
  const [sel_tdtm,   setToDate]     = useState(today);
  const [company,    setCompany]    = useState('');
  const [payType,    setPayType]    = useState('payment');
  const [ref_code,   setRefCode]    = useState('');
  const [sel_staff,  setStaff]      = useState('');

  const [data, setData]   = useState(null);
  const [items, setItems] = useState(null);

  const [dp_throttle, setDP]    = useState(50);

  const updateFilter = (apiData) =>
  {
    if (apiData) setData(apiData);

    // reset load
    setDP(C_INIT_SHOW_COUNT);

    // execute filter
    let ls = apiData || data;
    if (!ls) return;

    if (sel_fdtm) {
      let _ixkey = `ix_${by_date}`;
      let _ixd = ixday(sel_fdtm);
      ls = ls.filter(x => _ixd <= x[_ixkey]);
    }
    if (sel_tdtm) {
      let _ixkey = `ix_${by_date}`;
      let _ixd = ixday(sel_tdtm);
      ls = ls.filter(x => _ixd >= x[_ixkey]);
    }

    if (company) ls = ls.filter(x => x.company == company);

    let _ref = ref_code.toUpperCase().trim();
    if (ref_code) ls = ls.filter(x => -1<x.ref_code.toUpperCase().indexOf(_ref));

    switch (payType)
    {
      case '': break; // all
      case 'payment':
        ls = ls.filter(x => -1<['C','P','T','Q','F'].indexOf(x.payment_type));
        break;
      case 'other':
        ls = ls.filter(x => -1<['A','X','Z'].indexOf(x.payment_type));
        break;
      default:
        ls = ls.filter(x => payType == x.payment_type);
        break;
    }

    // update staff list
    setStaffList( Array.from(new Set(ls.map(x => x.create_by))).sort() );

    // further filter selected staff
    if (!!sel_staff) {
      ls = ls.filter(x => x.create_by === sel_staff);
    }
    setItems(ls);

  }

  const showEditModal = (pay) =>
  {
    let modal = <PaymentCard payment={pay} />;
    setModal(modal);
  }

  const searchByChequeRef = () =>
  {
    setItems(null);
    API.getPaymentByChequeRef(ref_code).then(data => {
      data.forEach(d => {
        d.pay_month = d.pay_month ? JSON.parse(d.pay_month) : null;
        d.ix_create = ixday(d.create_dtm);
        d.ix_modify = ixday(d.mod_dtm);
        d.ix_trans  = ixday(d.transfer_dtm);
      });
      updateFilter(data);
    });
  }

  const onScroll = (e) => {
    // progressive loading
    if (dp_throttle > items?.length) return;
    if (Math.ceil(20+e.target.scrollTop + e.target.clientHeight) >= e.target.scrollHeight) {
      setDP(dp_throttle + 100);
    }
  }

  const exportXls = () =>
  {
    setExporting(true);
    let M  = moment(queryMonth).format('M');
    let ix = moment(queryMonth).format('YYYYMM');

    let from_dtm = (sel_fdtm && Util.ShortDate(sel_fdtm)) || null;
    let to_dtm = (sel_tdtm && Util.ShortDate(sel_tdtm)) || null;
    let dto = {
       from_dtm
      ,to_dtm
      ,company
      ,type: String(payType)
      ,ref_code
      ,staff_name: sel_staff || null
    };

    API.exportPaymentRec(by_date, ix, dto).then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `${M}月收款紀錄_${ix_date}.xlsx`);
      setExporting(false);
    });
  }

  useEffect(() => {

    // display state
    setItems(null);

    // start load data
    let ix = moment(queryMonth).format('YYYYMM');
    API.getPaymentByMonth(by_date, ix).then(data => {
      data.forEach(d => {
        d.pay_month = d.pay_month ? JSON.parse(d.pay_month) : null;
        d.ix_create = ixday(d.create_dtm);
        d.ix_modify = ixday(d.mod_dtm);
        d.ix_trans  = ixday(d.transfer_dtm);
      })
      updateFilter(data);
      // update range
      let thisMonthIx = moment().format('YYYYMM');
      if (ix != thisMonthIx)
      {
        let _d = moment(ix+'01', 'YYYYMMDD').startOf('day').toDate();
        setFromDate(_d); // order matters
        setToDate(_d);
      } else {
        let _d = moment().startOf('day').toDate();
        setToDate(_d);   // order matters
        setFromDate(_d);
      }
    });
  }, [by_date, queryMonth])

  useEffect(() => {
    if (moment(sel_fdtm).isAfter(sel_tdtm))
    {
      // swap
      let [t1, t2] = [sel_tdtm, sel_fdtm];
      setFromDate(t1);
      setToDate(t2);
    } else {
      updateFilter();
    }
  }, [company, payType, ref_code, sel_fdtm, sel_tdtm, sel_staff]);

  return (
    <>
      <h1>紀錄 - 收款紀錄</h1>
      <div className="cheque-view">
        <div className="action-panel">
          <div className="row search-bar">
            <label className="field-row">
              <strong>搜尋</strong>
              <select value={by_date} onChange={e=>setByDate(e.target.value)}>
                <option value="trans">入賬</option>
                <option value="create">建立</option>
                <option value="modify">修改</option>
              </select>
            </label>
            <label className="field-row">
              <strong>月份</strong>
              <DatePicker selected={queryMonth} onChange={setQueryMonth}
                showMonthYearPicker
                dateFormat="MMM yyyy" />
            </label>
            <label className="field-row">
              <strong>由</strong>
              <DatePicker selected={sel_fdtm} onChange={setFromDate}
                minDate={queryMonth} maxDate={moment(queryMonth).endOf('month').toDate()}
                dateFormat="yyyy-MM-dd" />
            </label>
            <label className="field-row">
              <strong>至</strong>
              <DatePicker selected={sel_tdtm} onChange={setToDate}
                minDate={queryMonth} maxDate={moment(queryMonth).endOf('month').toDate()}
                dateFormat="yyyy-MM-dd" />
            </label>
            <label className="field-row">
              <strong>公司</strong>
              <select value={company} onChange={e=>setCompany(e.target.value)}>
                <option value="">全部</option>
                { Data.company.map(com =>
                  <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
                )}
              </select>
            </label>
            <label className="field-row">
              <strong>付款類型</strong>
              <select value={payType} onChange={e=>setPayType(e.target.value)}>
                <option value="">全部</option>
                <option value="payment">收益</option>
                <option value="nonpay">非支付</option>
                <option value="C">C - 現金</option>
                <option value="T">T - 轉賬</option>
                <option value="Q">Q - 支票</option>
                <option value="A">A - 調整</option>
                <option value="X">X - 壞賬</option>
                <option value="Z">Z - 賠償</option>
              </select>
            </label>
            <label className="field-row">
              <strong>負責同事</strong>
              <select value={sel_staff} onChange={e=>setStaff(e.target.value)}>
                <option value="">全部</option>
                { ls_staff.map(s => <option key={s} value={s}>{ s }</option>) }
              </select>
            </label>
            <label className="field-row">
              <strong>參考編號</strong>
              <input value={ref_code} placeholder="000-000"
                onChange={e=>setRefCode(e.target.value)}
                onBlur={e=>setRefCode(e.target.value.trim())}/>
            </label>
            <label className="field-row">
              <button className="btn blue" onClick={searchByChequeRef}>搜尋支票</button>
            </label>
          </div>
          <div>
            <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_DAY','VIEWER_NIGHT']}>
              { items?.length > 0 &&
                <button className="btn dark-green btn-export" disabled={exporting}
                  onClick={exportXls}>
                  <FontAwesomeIcon icon={faFileExcel} />
                  <span> 匯出</span>
                </button>
              }
            </Protected>
          </div>
        </div>
        { !!items &&
          <div className="row">
            <strong>顯示/搜尋/總數</strong>
            <span>{ Math.min(dp_throttle, items.length) } / { items.length } / { data.length }</span>
          </div>
        }
        <div className="cheque-view-body" onScroll={onScroll}>
        { !items ? <Loading/>
          :items.length <= 0 ? <p className="message yellow">沒有記錄</p>
          :<table className="data-table full-width">
            <colgroup>
              <col width="40px"  id="col-chq-btnmodal" />
              <col width="60px"  id="col-chq-company" />
              <col width="260px" id="col-chq-pay-month" />
              <col width="80px"  id="col-chq-loc" />
              <col width="120px" id="col-chq-psn" />
              <col width="300px" id="col-chq-customer" />
              <col width="100px" id="col-chq-amount" />
              <col width="80px"  id="col-chq-type" />
              <col width="200px" id="col-chq-ref" />
              <col width="100px" id="col-chq-transfer-date" />
              <col width="160px" id="col-chq-mod-date" />
              <col width="160px" id="col-chq-by" />
              <col width="auto"  id="col-chq-remarks" />
            </colgroup>
            <thead>
              <tr>
                <th className="col-chq-btnmodal"></th>
                <th className="col-chq-company">公司</th>
                <th className="col-chq-pay-month">付款月份</th>
                <th className="col-chq-loc">地點</th>
                <th className="col-chq-psn">車位</th>
                <th className="col-chq-customer">客戶</th>
                <th className="col-chq-amount">金額</th>
                <th className="col-chq-type">收付類型</th>
                <th className="col-chq-ref">參考編號</th>
                <th className="col-chq-transfer-date">入賬日期</th>
                <th className="col-chq-mod-date">紀錄日期</th>
                <th className="col-chq-by">負責同事</th>
                <th className="col-chq-remarks">備註</th>
              </tr>
            </thead>
            <tbody>
              { items.slice(0,dp_throttle).map((pay, i) =>
                <tr key={i}>
                  <td className="col-chq-btnmodal">
                    <button className="btn-edit" title="編輯" onClick={e=>showEditModal(pay)}>
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                  </td>
                  <td className="col-chq-company">{ Util.getCompanyName(pay.company) }</td>
                  <td className="col-chq-pay-month">
                    { (0 < pay.pay_month?.length)
                      ? pay.pay_month.map(pm =>
                          <div key={pm.l}>
                            { (pm.l!='*BALANCE(CR)*')
                              ? <a href={`/op/services/${pm.l}`}>{ pm.l }</a>
                              : <span>*</span>
                            }
                            { !!pm.n && (
                                pm.n == pm.x
                                ?<span> {ix2s(pm.n)}</span>
                                :<span> {ix2s(pm.n)} 至 {ix2s(pm.x)}</span>
                            )}
                          </div>
                        )
                      : <span>**</span>
                    }
                  </td>
                  <td className="col-chq-loc">
                    { pay.pay_month?.map(pm =>
                      <div key={pm.l}>{pm.dis}{pm.loc}</div>
                    )}
                  </td>
                  <td className="col-chq-psn">
                    { pay.pay_month?.map(pm =>
                      <div key={pm.l}>{pm.p}</div>
                    )}
                  </td>
                  <td className="col-chq-customer">{ pay.cust_name } ({pay.uid})</td>
                  <td className="col-chq-amount">${ Util.nf2(pay.amount) }</td>
                  <td className="col-chq-type">{ Util.getPaymentType(pay.payment_type) }</td>
                  <td className="col-chq-ref">{ pay.ref_code }</td>
                  <td className="col-chq-transfer-date">{ Util.ShortDate(pay.transfer_dtm) }</td>
                  <td className="col-chq-create-date">{ Util.FullDate(pay.create_dtm) }</td>
                  <td className="col-chq-by" title={`更新日期: ${Util.ShortDate(pay.mod_dtm)}`}>{ pay.create_by }</td>
                  <td className="col-chq-remarks">{ pay.remarks }</td>
                </tr>
              )}
            </tbody>
          </table>
        }
        </div>
      </div>
      <ModalScreen title="修改付款紀錄" show={!!modal} onClose={e=>setModal(null)}>
        { modal }
      </ModalScreen>
    </>
  );
}

export default PaymentView;
